import { useEffect, useRef } from "react";
import useTipper from "@/hooks/use-tipper";

const CLIENT = "ca-pub-6399370402566527";

/**
 * Manual AdSense unit. Renders <ins class="adsbygoogle"> and pushes to
 * adsbygoogle on mount. Requires a valid slot id.
 *
 * Skipped entirely if the visitor is a claimed supporter (localStorage flag).
 * Until Google approves the domain, the slot renders blank — expected.
 */
export default function AdBanner({
  slot,
  format = "auto",
  fullWidth = true,
  className = "",
  testid = "ad-banner",
}) {
  const pushed = useRef(false);
  const tipper = useTipper();

  useEffect(() => {
    if (pushed.current || tipper) return;
    pushed.current = true;
    try {
      // eslint-disable-next-line no-undef
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      /* AdSense script hasn't loaded (dev/preview) — safe to ignore */
    }
  }, [slot, tipper]);

  if (!slot || tipper) return null;

  return (
    <div
      data-testid={testid}
      className={`rounded-xl overflow-hidden border border-white/5 bg-[#0c0e15] ${className}`}
    >
      <ins
        className="adsbygoogle"
        style={{ display: "block", minHeight: 90 }}
        data-ad-client={CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={fullWidth ? "true" : "false"}
      />
    </div>
  );
}
